import React, { useEffect } from "react";
import ReactRotatingText from "react-rotating-text";
import Tilt from "react-parallax-tilt";

import Aos from "aos";
import "aos/dist/aos.css";

const Home = () => {
	useEffect(() => {
		Aos.init({
			duration: 1500,
			delay: 1000,
			offset: 0,
			easing: "ease",
			once: true,
			mirror: false,
			disable: () => {
				return window.innerWidth < 600;
			},
		});

		window.scrollTo(0, 0);
	}, []);

	return (
		<div className="home">
			<div className="home-headings">
				<span>&#62; </span>
				<ReactRotatingText
					items={[
						"Hello!",
						'My name is " Tilak Mahawar " :) ',
						"I am a Front-end Web Engineer! </>",
						"Have a Great Day ... !",
					]}
				/>
			</div>
			<div className="profile-container" data-aos="fade-up">
				<div className="label">
					<i className="far fa-hand-pointer" />
					Hover Me!
				</div>
				<Tilt tiltMaxAngleX={15} tiltMaxAngleY={15}>
					<div className="profile-card">
						<div className="profile-content">
							<div className="social-icons">
								<a
									href="https://github.com/mr-mahawar"
									target="_blank"
									rel="noreferrer"
								>
									<i className="fab fa-github" />
								</a>
								<a
									href="https://www.linkedin.com/in/tilak-mahawar-782851200/"
									target="_blank"
									rel="noreferrer"
								>
									<i className="fab fa-linkedin" />
								</a>
								<a
									href="https://twitter.com/mr_mahawar"
									target="_blank"
									rel="noreferrer"
								>
									<i className="fab fa-twitter" />
								</a>
								<a
									href="https://www.instagram.com/__mr.mahawar__/"
									target="_blank"
									rel="noreferrer"
								>
									<i className="fab fa-instagram" />
								</a>
							</div>
						</div>
					</div>
				</Tilt>
			</div>
		</div>
	);
};

export default Home;
